import React from "react";
import get from "lodash/get";
import find from "lodash/find";
import filter from "lodash/filter";
import debounce from "lodash/debounce";
import map from "lodash/map";
import forEach from "lodash/forEach";
import { connect } from "react-redux";
import {
  Alert,
  Icon,
  Layout,
  Input,
  InputNumber,
  Select,
  Table,
  Menu,
  Dropdown,
  Tooltip,
  Button,
  Checkbox,
  Badge,
} from "antd";
import { withRouter, Link } from "react-router-dom";

import classes from "./Enrolments.css";

import isAuthenticated from "../../utils/isAuthenticated";
import {
  getSubjectSearchRequest,
  getSitesRequest,
  getSubjectsFilterGenerator,
} from "../../api/requests";
import { setAccountInfoEnrollmentPagination, logout } from "../../reducers/user/actions";
import {
  getDrugManagementStatus,
  getValidationRequiredStatus,
  getUserShortTimezone,
  getDrugAccessPermissionInEnrollment,
  getUserTimezone,
  getUserEnrolmentPagination,
  getValidateRandomizationAccessPermission,
  getReadPartialAPIAccessConfigPermission,
  getCohortsActiveStatus,
  getPatientProfileDeletePermission,
} from "../../reducers/user/selectors";
import { withParams } from "../../utils/url";
import moment from "moment-timezone";
import { withNamespaces } from "react-i18next";
import cloneDeep from "lodash/cloneDeep";

const routes = require("../../routes.json");

const { Content } = Layout;
const { Search } = Input;
const { Option, OptGroup } = Select;

const renderIcon = (status) => {
  return (
    <div className={classes.iconStatusWrapper}>
      {status === "green" && (
        <Icon type="check-square" className={classes.checkIcon} />
      )}
      {status === "red" && (
        <Icon type="warning" className={classes.warningIcon} />
      )}
      {status === "orange" && (
        <Icon type="clock-circle" className={classes.clockIcon} />
      )}
      {status === "gray" && (
        <Icon type="clock-circle" className={classes.checkIconGray} />
      )}
      {status === "pending" && (
        <Icon type="clock-circle" className={classes.checkIconGray} />
      )}
    </div>
  );
};

class Enrolments extends React.Component {
  constructor(props) {
    super(props);

    const queryParams = new URLSearchParams(this.props.location.search);

    this.state = {
      subject: [],
      subjectSearch: null,
      errorMessage: null,
      responseMessage: null,
      isLoading: false,
      sites: [],
      site: null,
      voided: null,
      filter: queryParams.get("randomization") ? "event" : "",
      eventsSelected: queryParams.get("randomization") ? {randomize: true} : {},
      order: "desc",
      currentPage: 1,
      total: 1,
      pageSize: this.props.getUserEnrolmentPagination || 25,
      eventVisibleDropdown: false,
      sortedInfo: { columnKey: "created", order: "descend" },
      filtersBy: [],
      filtersOperation: [],
      filtersValue: [],
      filtersRandomizationRelationships: [],
    };
  }

  eventList() {
    return {
      profile: this.props.i18n.t("Profile"),
      randomize: this.props.i18n.t("Randomize"),
      validation: this.props.i18n.t("Validation"),
      drug_administered: this.props.i18n.t("Drug administered"),
      death: this.props.i18n.t("Death"),
    };
  }

  async componentDidMount() {
    this.getSubjects();

    try {
      this.getSubjectsFilterGenerator();
      const { data } = await getSitesRequest();
      this.setState({ sites: data });
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      console.log(e);
    }
  }

  getSubjectsFilterGenerator = async () => {
    const {
      data: { relationships },
    } = await getSubjectsFilterGenerator();
    this.setState({
      filtersRandomizationRelationships: get(
        find(relationships, ({ title }) => title === "randomization"),
        "columns"
      ),
    });
  };

  onSubjectSearch = async (value) => {
    this.setState(
      { subjectSearch: value, filter: null, site: null, voided: null, eventsSelected: {}, currentPage: 1 },
      this.getSubjects
    );
  };

  getSubjects = debounce(
    async (page = this.state.currentPage, per_page = this.state.pageSize) => {
      this.setState({
        errorMessage: null,
        isLoading: true,
        responseMessage: null,
      });

      const filterParams = {};

      forEach(this.state.filtersValue, (value, i) => {
        if (
          value &&
          this.state.filtersOperation[i] &&
          this.state.filtersOperation[i]
        ) {
          filterParams[
            `randomization__${this.state.filtersBy[i].split("__")[0]}${
              this.state.filtersOperation[i] !== "equal"
                ? `__${this.state.filtersOperation[i]}`
                : ""
            }`
          ] = value;
        }
      });

      try {
        const { data } = await getSubjectSearchRequest({
          subjectSearch: this.state.subjectSearch,
          filter_by: this.state.filter,
          site_code: this.state.site,
          voided: this.state.voided,
          events: Object.keys(this.state.eventsSelected).join(","),
          event_status: Object.values(this.state.eventsSelected).join(","),
          order_direction: this.state.order,
          page,
          per_page,
          order_column: get(this.state, "sortedInfo.columnKey"),
          filter_params: filterParams,
        });

        if (Array.isArray(data.data)) {
          this.setState({
            subject: data.data,
            total: data.total_pages * per_page,
            currentPage: page,
          });
        } else {
          this.setState({
            subject: [data],
            total: 1 * per_page,
            currentPage: page,
          });
        }
      } catch (e) {
        if (get(e, "response.status") === 401) {
          this.props.logout();
          return;
        }
        this.setState({
          subject: null,
          errorMessage: get(e, "response.data.error", "Error"),
        });
      }

      this.setState({ isLoading: false });
    },
    200
  );

  onSubjectChange = (e) => {
    this.setState({ subjectSearch: e.target.value });
  };

  clearFilters = () => {
    this.setState(
      {
        subjectSearch: null,
        site: null,
        voided: null,
        filter: null,
        eventsSelected: {},
        sortedInfo: null,
        currentPage: 1,
      },
      this.getSubjects
    );
  };

  handleFilterChange = (value) => {
    this.setState(
      {
        filter: value,
        site: null,
        voided: null,
        eventsSelected: {},
        subjectSearch: null,
        sortedInfo: null,
        currentPage: 1,
      },
      this.getSubjects
    );
  };
  handleSiteChange = (value) => {
    this.setState({ site: value, sortedInfo: null, currentPage: 1 }, this.getSubjects);
  };

  handleVoidedChange = (value) => {
    this.setState({ voided: value, sortedInfo: null, currentPage: 1 }, this.getSubjects);
  };
  handleOrderChange = (value) => {
    this.setState({ order: value, sortedInfo: null, currentPage: 1 }, this.getSubjects);
  };

  handleMenuClick = (e) => {
    if (e.key === "3") {
      this.setState({ eventVisibleDropdown: false });
    }
  };

  handleVisibleChange = (flag) => {
    this.setState({ eventVisibleDropdown: flag });
  };

  hideEventDropdown = () => {
    this.setState({ eventVisibleDropdown: false });
  };

  onSelectEvent = (eventName) => () => {
    this.setState((state) => {
      let eventsSelected;

      if ([true, false].includes(state.eventsSelected[eventName])) {
        eventsSelected = { ...state.eventsSelected };
        delete eventsSelected[eventName];
      } else {
        eventsSelected = { ...state.eventsSelected, [eventName]: true };
      }

      if (eventName === "sae") {
        if (
          ["not_entered", "is_occurred", "not_occurred"].includes(
            state.eventsSelected[eventName]
          )
        ) {
          eventsSelected = { ...state.eventsSelected };
          delete eventsSelected[eventName];
        } else {
          eventsSelected = {
            ...state.eventsSelected,
            [eventName]: "not_occurred",
          };
        }
      }

      return { eventsSelected, sortedInfo: null, currentPage: 1 };
    }, this.getSubjects);
  };

  onSelectEventOccured = (eventName, value) => () => {
    this.setState((state) => {
      let eventsSelected = state.eventsSelected[eventName]
        ? { ...state.eventsSelected, [eventName]: false }
        : { ...state.eventsSelected, [eventName]: true };

      if (eventName === "sae") {
        if (get(state, "eventsSelected.sae") === value) {
          eventsSelected.sae = "not_occurred";
        } else {
          eventsSelected.sae = value;
        }
      }

      return {
        eventsSelected,
        sortedInfo: null,
        currentPage: 1
      };
    }, this.getSubjects);
  };

  handleTableChange = (pagination, filters, sorter) => {
    this.setState(
      {
        isLoading: true,
        pageSize: pagination.pageSize,
        sortedInfo: sorter,
        order:
          get(sorter, "order") === "ascend"
            ? "asc"
            : get(sorter, "order") === "descend"
            ? "desc"
            : "asc",
      },
      () => this.getSubjects(pagination.current, pagination.pageSize)
    );
  };

  renderFilterItem = (index = this.state.filtersBy.length) => {
    const {
      filtersBy,
      filtersOperation,
      filtersValue,
      filtersRandomizationRelationships,
    } = this.state;

    return (
      <div className={classes.wrapperFilterItem} key={filtersBy[index]}>
        <div className={classes.searchWrapperFilter}>
          <label className={classes.searchWrapperFilterItem}>
            <b className={classes.searchWrapperLabel}>
              {this.props.i18n.t("Filter by")}
            </b>
            <Select
              onChange={this.handleCustomFilterChange(index)}
              value={filtersBy[index]}
              style={{ width: "100%" }}
              placeholder={this.props.i18n.t("Select")}
            >
              {map(
                filter(filtersRandomizationRelationships, ({ type }) =>
                  ["INTEGER", "FLOAT", "TEXT"].includes(type)
                ),
                ({ column, type }, i) => (
                  <Option
                    key={i}
                    value={`${column}__${type}`}
                    // disabled={filtersBy.includes("category")}
                  >
                    {column}
                  </Option>
                )
              )}
            </Select>
          </label>
        </div>

        {filtersBy[index] && (
          <label className={classes.searchWrapperFilterItem}>
            <b className={classes.searchWrapperLabel}>Operation</b>
            <Select
              onChange={this.handleCustomFilterOperationChange(index)}
              value={filtersOperation[index]}
              style={{ width: "100%" }}
              placeholder={this.props.i18n.t("Select")}
            >
              {["INTEGER", "FLOAT"].includes(
                filtersBy[index].split("__")[1]
              ) && (
                <OptGroup label={this.props.i18n.t("Operator")}>
                  <Option value="gt">{this.props.i18n.t("Greater than")}</Option>
                  <Option value="lt">{this.props.i18n.t("Lower than")}</Option>
                  <Option value="equal">{this.props.i18n.t("Equal")}</Option>
                </OptGroup>
              )}
              {["TEXT"].includes(filtersBy[index].split("__")[1]) && (
                <OptGroup label={this.props.i18n.t("Operator")}>
                  <Option value="contains">{this.props.i18n.t("Contains")}</Option>
                  <Option value="startswith">{this.props.i18n.t("Starts with")}</Option>
                  <Option value="endswith">{this.props.i18n.t("Ends with")}</Option>
                  <Option value="equal">{this.props.i18n.t("Equal")}</Option>
                </OptGroup>
              )}
            </Select>
          </label>
        )}

        {filtersBy[index] && (
          <label className={classes.searchWrapperFilterItem}>
            <b className={classes.searchWrapperLabel}>Value</b>
            {["INTEGER", "FLOAT"].includes(filtersBy[index].split("__")[1]) && (
              <InputNumber
                disabled={!filtersBy[index] || !filtersOperation[index]}
                onChange={(val) => {
                  this.handleCustomFilterValueChange(index)(val);
                }}
                value={filtersValue[index]}
                style={{ width: "100%" }}
                placeholder={this.props.i18n.t("Value")}
              />
            )}
            {["TEXT"].includes(filtersBy[index].split("__")[1]) && (
              <Input
                disabled={!filtersBy[index] || !filtersOperation[index]}
                onChange={(e) => {
                  this.handleCustomFilterValueChange(index)(
                    get(e, "target.value")
                  );
                }}
                value={filtersValue[index]}
                style={{ width: "100%" }}
                placeholder={this.props.i18n.t("Value")}
              />
            )}
          </label>
        )}

        {filtersValue[index] && (
          <span
            className={classes.clearButton}
            onClick={this.clearFilter(index)}
          >
            {this.props.i18n.t("Remove")}
          </span>
        )}
      </div>
    );
  };

  handleCustomFilterChange = (index) => (value) => {
    this.setState((state) => {
      const filtersBy = cloneDeep(state.filtersBy);
      const filtersValue = cloneDeep(state.filtersValue);
      const filtersOperation = cloneDeep(state.filtersOperation);

      filtersBy[index] = value;
      delete filtersValue[index]; // TODO: null?
      delete filtersOperation[index];

      return { filtersBy, filtersOperation, filtersValue };
    });
  };

  handleCustomFilterOperationChange = (index) => (value) => {
    this.setState((state) => {
      const filtersOperation = cloneDeep(state.filtersOperation);
      const filtersValue = cloneDeep(state.filtersValue);
      filtersOperation[index] = value;
      delete filtersValue[index];
      return { filtersOperation, filtersValue };
    });
  };

  handleCustomFilterValueChange = (index) => (val) => {
    this.setState((state) => {
      const filtersValue = cloneDeep(state.filtersValue);
      filtersValue[index] = val;
      return { filtersValue, currentPage: 1 };
    }, this.getSubjects);
  };

  clearFilter = (index) => () => {
    this.setState((state) => {
      const filtersBy = cloneDeep(state.filtersBy);
      const filtersValue = cloneDeep(state.filtersValue);

      filtersBy.splice(index, 1);
      filtersValue.splice(index, 1);

      return { filtersBy, filtersValue, currentPage: 1 };
    }, this.getSubjects);
  };

  render() {
    const {
      errorMessage,
      isLoading,
      responseMessage,
      subjectSearch,
      subject,
      sites,
      site,
      filter,
      filtersBy,
      filtersValue,
      currentPage,
      total,
      pageSize,
      eventVisibleDropdown,
      eventsSelected,
      sortedInfo,
    } = this.state;

    const {
      isDrugManagementActive,
      isValidationRequired,
      isCohortsActive,
      drugAccessPermissionInEnrollment,
      getValidateRandomizationAccessPermission,
      getReadPartialAPIAccessConfigPermission,
    } = this.props;

    const drugColumn = {
      dataIndex: isDrugManagementActive ? "drug" : "treatment_arm_name",
      key: isDrugManagementActive ? "drug" : "treatment_arm_name",
      title: isDrugManagementActive
        ? this.props.i18n.t("Drug Allocated")
        : this.props.i18n.t("Treatment Allocated"),
      render: (val, row) =>
        isDrugManagementActive ? (
          <div>
            {row.drugs ? (
              <div>
                {map(row.drugs, ({ drug_status, vial_number }, i) => (
                  <div key={i}>
                    {vial_number}
                    <br />
                    <Badge
                      count={drug_status.replace(/_/g, " ")}
                      style={{ backgroundColor: "#2968AE" }}
                    />
                  </div>
                ))}
              </div>
            ) : (
              <div>
                {get(val, "vial_number")}
                <br />
                <Badge
                  count={get(val, "drug_status", "").replace(/_/g, " ")}
                  style={{ backgroundColor: "#2968AE" }}
                />
              </div>
            )}
          </div>
        ) : (
          <div>{val}</div>
        ),
      sorter: true,
      sortOrder: get(sortedInfo, "columnKey") === "drug" && sortedInfo.order,
    };

    let columns = [
      {
        dataIndex: "site",
        key: "site",
        title: this.props.i18n.t("Site"),
        render: (val) => (
          <span>
            {get(val, "code")} - {get(val, "name")}
          </span>
        ),
        sorter: true,
        sortOrder: get(sortedInfo, "columnKey") === "site" && sortedInfo.order,
      },
      {
        dataIndex: "code",
        key: "code",
        title: this.props.i18n.t("Subject"),
        render: (val, row) => (
          <div>
            <Tooltip
              placement="topLeft"
              title={this.props.i18n.t("View Subject Profile")}
            >
              <Link
                to={withParams(routes.admin.patientProfileSingle, {
                  subjectID: get(row.profile, "code"),
                  show_voided: this.state.voided === 'true' ? "true" : undefined,
                })}
              >
                {val}
              </Link>
            </Tooltip>
          </div>
        ),
        sorter: true,
        sortOrder: get(sortedInfo, "columnKey") === "code" && sortedInfo.order,
      },
      {
        dataIndex: "created",
        key: "created",
        title: this.props.i18n.t("NamespaceEnrolments:Created date/time"),
        render: (val, record) => (
          <span>
            {moment
              .utc(val)
              .tz(
                this.props.userTimezone ||
                  get(record, "site.time_zone") ||
                  "UTC"
              )
              .format("YYYY-MM-DD HH:mm")}{" "}
            {this.props.userShortTimezone ||
              get(record, "site.short_tz") ||
              "UTC"}
          </span>
        ),
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "created" && sortedInfo.order,
      },
      {
        dataIndex: "user",
        key: "user",
        title: this.props.i18n.t("NamespaceEnrolments:Created/randomized by"),
        render: (val) => <span>{get(val, "username")}</span>,
        sorter: false,
      },
    ];

    if (isCohortsActive) {
      columns.push({
        dataIndex: "study_cohort",
        key: "study_cohort",
        title: this.props.i18n.t("Cohort"),
        render: (val, record) =>
          (get(record, "cohort_display")) ? (
            <span>{get(record, "cohort_display")}</span>
          ): (
            ""
          ),
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "study_cohort" &&
          sortedInfo.order,
      });
    }

    if (getReadPartialAPIAccessConfigPermission) {
      columns.push({
        dataIndex: "api_connections",
        key: "api_connections",
        title: this.props.i18n.t("Api Connections"),
        render: (val) => <span>{get(val, "display")}</span>,
        sorter: false
      });
    }

    if (isValidationRequired && getValidateRandomizationAccessPermission) {
      columns.push({
        dataIndex: "validation_conducted",
        key: "validation_conducted",
        title: this.props.i18n.t("Validation"),
        render: (val) =>
          val && <Icon type="check-square" className={classes.checkIcon} />,
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "validation_conducted" &&
          sortedInfo.order,
      });
    }

    if (drugAccessPermissionInEnrollment) {
      columns.splice(2, 0, drugColumn);
    }

    return (
      <div>
        <Layout className={classes.parentContainer}>
          <Content className={classes.content}>
            <h3 className="headline-default">
              {this.props.i18n.t("Subject Randomization List")}
            </h3>

            <div className={classes.searchWrapper}>
              <label className={classes.searchWrapperSearch}>
                <b className={classes.searchWrapperLabel}>
                  {this.props.i18n.t("SEARCH")}
                </b>
                <Search
                  placeholder={this.props.i18n.t(
                    "NamespaceEnrolments:By SubjectID"
                  )}
                  enterButton={this.props.i18n.t("Search")}
                  size="large"
                  onSearch={this.onSubjectSearch}
                  value={subjectSearch}
                  onChange={this.onSubjectChange}
                  style={{ maxWidth: "500px" }}
                />
              </label>

              <div className={classes.searchWrapperFilter}>
                <label className={classes.searchWrapperFilterItem}>
                  <b className={classes.searchWrapperLabel}>
                    {this.props.i18n.t("Filter by")}
                  </b>
                  <Select
                    onChange={this.handleFilterChange}
                    value={filter}
                    style={{ width: "100%" }}
                    placeholder={this.props.i18n.t("Select")}
                  >
                    <Option value="site">{this.props.i18n.t("Site")}</Option>
                    <Option value="event">{this.props.i18n.t("Event")}</Option>
                    {this.props.getPatientProfileDeletePermission && <Option value="voided">{this.props.i18n.t("Voided")}</Option>}
                  </Select>
                </label>

                {filter === "voided" && (
                  <label className={classes.searchWrapperFilterItem}>
                    <b className={classes.searchWrapperLabel}>
                      {this.props.i18n.t("Show Voided")}
                    </b>
                    <Select
                      onChange={this.handleVoidedChange}
                      value={this.state.voided}
                      optionFilterProp="children"
                      filterOption
                      style={{ width: "100%" }}
                      placeholder={this.props.i18n.t("Select")}
                    >
                      <Option value="true">{this.props.i18n.t("Yes")}</Option>
                      <Option value="false">{this.props.i18n.t("No")}</Option>
                    </Select>
                  </label>
                )}

                {filter === "site" && (
                  <label className={classes.searchWrapperFilterItem}>
                    <b className={classes.searchWrapperLabel}>
                      {this.props.i18n.t("Site")}
                    </b>
                    <Select
                      onChange={this.handleSiteChange}
                      value={site}
                      showSearch
                      optionFilterProp="children"
                      filterOption
                      style={{ width: "100%" }}
                      placeholder={this.props.i18n.t("Select")}
                    >
                      {sites
                        .sort((a, b) => a.code - b.code)
                        .map((site) => (
                          <Option key={site.id} value={site.code}>
                            {site.code} - {site.name}
                          </Option>
                        ))}
                      <Option value="">{this.props.i18n.t("All sites")}</Option>
                    </Select>
                  </label>
                )}

                {filter === "event" && (
                  <label className={classes.searchWrapperFilterItem}>
                    <b className={classes.searchWrapperLabel}>
                      {this.props.i18n.t("Event")}
                    </b>
                    <br />
                    <Dropdown
                      overlay={
                        <Menu onClick={this.handleMenuClick}>
                          {Object.keys(this.eventList()).map((eventName) => (
                            <Menu.Item
                              key={eventName}
                              className={classes.eventDropdownItem}
                            >
                              <Checkbox
                                onChange={this.onSelectEvent(eventName)}
                                checked={[
                                  true,
                                  false,
                                  "not_entered",
                                  "is_occurred",
                                  "not_occurred",
                                ].includes(eventsSelected[eventName])}
                              >
                                {this.eventList()[eventName]}
                              </Checkbox>
                              {eventName !== "sae" &&
                                [true, false].includes(
                                  eventsSelected[eventName]
                                ) && (
                                  <div>
                                    <Checkbox
                                      onChange={this.onSelectEventOccured(
                                        eventName
                                      )}
                                      checked={eventsSelected[eventName]}
                                    >
                                      {this.props.i18n.t(
                                        "NamespaceEnrolments:Has occurred?"
                                      )}
                                    </Checkbox>
                                  </div>
                                )}

                              {eventName === "sae" &&
                                [
                                  "not_entered",
                                  "is_occurred",
                                  "not_occurred",
                                ].includes(eventsSelected["sae"]) && (
                                  <div>
                                    <Checkbox
                                      onChange={this.onSelectEventOccured(
                                        eventName,
                                        "is_occurred"
                                      )}
                                      checked={
                                        eventsSelected[eventName] ===
                                        "is_occurred"
                                      }
                                    >
                                      {this.props.i18n.t(
                                        "NamespaceEnrolments:Has occurred?"
                                      )}
                                    </Checkbox>
                                    <Checkbox
                                      onChange={this.onSelectEventOccured(
                                        eventName,
                                        "not_entered"
                                      )}
                                      checked={
                                        eventsSelected[eventName] ===
                                        "not_entered"
                                      }
                                    >
                                      {this.props.i18n.t("Not entered")}
                                    </Checkbox>
                                  </div>
                                )}
                            </Menu.Item>
                          ))}
                          <Menu.Item>
                            <Button
                              type="primary"
                              size="small"
                              onClick={this.hideEventDropdown}
                            >
                              {this.props.i18n.t("NamespaceEnrolments:Ok")}
                            </Button>
                          </Menu.Item>
                        </Menu>
                      }
                      trigger={["click"]}
                      onVisibleChange={this.handleVisibleChange}
                      visible={eventVisibleDropdown}
                    >
                      <div>
                        {Object.keys(eventsSelected).length > 0 ? (
                          Object.keys(eventsSelected).map((eventName, i) => (
                            <span
                              key={eventName}
                              style={{
                                color: eventsSelected[eventName]
                                  ? "#49C850"
                                  : "#f00",
                              }}
                            >
                              {i !== 0 && ", "} {this.eventList()[eventName]}
                            </span>
                          ))
                        ) : (
                          <span>
                            {this.props.i18n.t(
                              "NamespaceEnrolments:Select events"
                            )}
                          </span>
                        )}
                      </div>
                    </Dropdown>
                  </label>
                )}

                <span
                  className={classes.clearButton}
                  onClick={this.clearFilters}
                >
                  {this.props.i18n.t("Clear")}
                </span>
              </div>
            </div>

            <div className={classes.customFiltersWrapper}>
              {filtersBy.map((_, index) => this.renderFilterItem(index))}

              {filtersBy.length === filtersValue.length &&
                filtersBy.length !== 4 &&
                this.renderFilterItem()}
            </div>

            {errorMessage && <Alert type="error" message={errorMessage} />}

            {responseMessage && (
              <Alert type="success" message={responseMessage} />
            )}

            {/*<div style={{ overflowY: "auto" }}>*/}
            <div>
              <Table
                style={{ minWidth: "700px" }}
                columns={columns}
                dataSource={subject}
                loading={isLoading}
                rowKey="id"
                onChange={this.handleTableChange}
                pagination={{
                  onShowSizeChange: (current, size) => {
                    this.setState({ pageSize: size });
                    this.props.setAccountInfoEnrollmentPagination(size);
                  },
                  current: currentPage,
                  total,
                  pageSize,
                  showSizeChanger: true,
                  pageSizeOptions: ["10", "25", "50", "100"],
                  position: 'both',
                }}
              />
            </div>

            {isLoading && <Icon type="loading" />}

            <br />

            <h4 className="headline-default">{this.props.i18n.t("Legend")}</h4>
            <p className={classes.legendItem}>
              <Icon type="check-square" className={classes.checkIcon} />{" "}
              <b>{this.props.i18n.t("Complete")}</b>
            </p>

            <p className={classes.legendItem}>
              <Icon type="warning" className={classes.warningIcon} />{" "}
              <b>{this.props.i18n.t("Alert")}</b>
            </p>

            <p className={classes.legendItem}>
              <Icon type="clock-circle" className={classes.checkIconGray} />{" "}
              <b>{this.props.i18n.t("Pending")}</b>
            </p>
          </Content>
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userTimezone: getUserTimezone(state),
  userShortTimezone: getUserShortTimezone(state),
  isDrugManagementActive: getDrugManagementStatus(state),
  drugAccessPermissionInEnrollment: getDrugAccessPermissionInEnrollment(state),
  isValidationRequired: getValidationRequiredStatus(state),
  isCohortsActive: getCohortsActiveStatus(state),
  getUserEnrolmentPagination: getUserEnrolmentPagination(state),
  getValidateRandomizationAccessPermission: getValidateRandomizationAccessPermission(state),
  getReadPartialAPIAccessConfigPermission: getReadPartialAPIAccessConfigPermission(state),
  getPatientProfileDeletePermission: getPatientProfileDeletePermission(state),
});

const mapDispatchToProps = { setAccountInfoEnrollmentPagination, logout };

export default isAuthenticated(
  connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(withRouter(Enrolments)))
);



// WEBPACK FOOTER //
// ./src/containers/Enrolments/Enrolments.js